export const ajaxButton = (element, action, data, callback = false) => {
  
  element.addEventListener('click', () => {
      
    if( element.getAttribute('data-request') ) {
      return;
    }

    element.classList.add('tangible-live-ajax-trigger');
    element.setAttribute('data-request', 'waiting')

    /**
     * @see https://github.com/TangibleInc/framework/tree/main/ajax
     */

    const { ajax } = window.Tangible
    
    ajax(action, data)
      .then(callback !== false ? callback : () => location.reload())
      .catch(error => console.error(error))
  })

}
